export const parseJwtPayload = (token) => {
  if (!token) return null
  const parts = token.split('.')
  if (parts.length !== 3) return null
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

export const isTokenValid = (tokenKey) => {
  const token = localStorage.getItem(tokenKey)
  if (!token) return false
  const payload = parseJwtPayload(token)
  if (!payload || !payload.exp) return false
  const nowSec = Math.floor(Date.now() / 1000)
  return payload.exp > nowSec
}

export const clearUserAuth = () => {
  localStorage.removeItem('user_token')
  localStorage.removeItem('user_profile')
}

export const syncUserSession = () => {
  if (!isTokenValid('user_token')) {
    clearUserAuth()
    return false
  }
  return true
}
